import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Alert, Button, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';
import CommonPagination from '../components/CommonPagination';

import CommonToast from '../components/CommonToast';
import CommonConfirmModal from '../components/CommonConfirmModal';
import CommonAlert from '../components/CommonAlert';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonButton from '../components/CommonButton';
import CommonDropdown from '../components/CommonDropdown';
import CommonFile from '../components/CommonFile';
import CustomDatePicker from "../components/CommonDatePicker";

import CommonLoadingBar from '../components/CommonLoadingBar';

import CommonPreviewFileModal from '../components/CommonPreviewFileModal';

import CommonTokenExpired from '../components/CommonTokenExpired';

import * as constants from '../../config/constants/AppConstants';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

import { GlobalStates } from '../states/GlobalStates';

/** individual page state */
import { PageDataState } from '../states/TypeAEnterpriseProfileState';

/** requester handle */
import requester from "../../library/Requester"; 

/** define end point */
const TABLE = `type_a_new_student_dual_coop_profile`;
const URL = `api/master/${TABLE}`;

const PARENT = 'type_a_new_student_dual_coop_id';

class InlineTypeAEnterprise extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);

        this.inlineInputRowRef = React.createRef();
    }

    initialize = async () => {
        let {fkId, fkVal} = this.props;
        
        await Actions.parametersInline(this.updateState, PARENT, {id: fkId, value: fkVal});
        
        if (fkId && fkVal) {;
            await this.loadMasterbase();
            await this.loadDataTable();
            await this.setDefaultInputs();
        }
    }    

    loadMasterbase = async () => {        
        let sets = [
            { key: "education_type", filter: [{field: "status", value: "0"}] }, 

            { key: "enterprise", filter: [{field: "status", value: "0"}] }, 
            
            { key: "education_level", filter: [{field: "status", value: "0"}] }, 

            { key: "faculty", filter: [{field: "status", value: "0"}] }, 
            { key: "department", filter: [{field: "status", value: "0"}] }, 
            { key: "department_work", filter: [{field: "status", value: "0"}] }, 
        ]; 
        
        await Actions.loadMasterbase(this.updateState, sets);
    }    

    loadDataTable = async (search=false) => { 
        const { Searchs, DataTable } = this.state;
        await Actions.loadDataTable( 
            this.updateState, 
            `${URL}/pagination`, 
            fn.getInputSearch({...Searchs, page: { id: 'page', value: search ? 1 : DataTable.pagination.currentPage }})
        );
    }

    updateSomething = async (obj, element, pk) => {
        await Actions.updateSomething(this.updateState, `${URL}/update-something`, element, pk, obj, this.loadDataTable);
    }

    reorder = async (obj) => {
        await Actions.reorder(this.updateState,`${URL}/reorder`, obj, this.loadDataTable);
    }

    setDefaultInputs = async () => {
        await Actions.setDefaultInputs(this.updateState, PARENT, async () => {
        });
    }    

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'Inline', mode: 'update', bool: true}
        );

        setTimeout(() => {
            if (this.inlineInputRowRef && this.inlineInputRowRef.current) {
                this.inlineInputRowRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }, 100);         
    }

    resetInlineInputs = () => {
        Actions.handleResetActionInline(this.updateState);
        Actions.handleDiscardInputs(this.updateState, 'Inputs');
        this.setDefaultInputs();
    }
                                                          
    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state; 
        await Actions.submitData(
            this.updateState,
            `${URL}`,
            Action.Mode, 
            fn.getInputForm({...Inputs}),
            this.loadDataTable        
        );

        let result = this.state.Action.Alert.mode;
        
        if(['new-success', 'update-success'].includes(result)){ 
            this.resetInlineInputs();
        }
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
        await this.setDefaultInputs();
    }
   
    componentDidMount = async () => { 
        await this.initialize();
    };

    componentDidUpdate = async (prevProps) => {
        if (prevProps.fkVal !== this.props.fkVal && !util.isEmpty(this.props.fkVal)) {
            await this.initialize();
        }        
    }

    render = () => {

        let { Action, DataTable, Inputs, Masterbase, Deletes, Operation, Parameters, Token } = this.state;

        let { onDrillDownInline } = this.props

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;

        let { show, mode } = Action.Inline;

        let { Submit } = Operation;

        let isLoading = Action.Loading.submit;

        const isFk = Parameters[PARENT]?.parameters?.element?.find(item => item.id === PARENT)?.value ?? null;

        return (
            <Container fluid className="data-table-container">

                <CommonTokenExpired Token={Token} />
                
                <CommonPreviewFileModal
                    Action={Action}
                    onClose={() => Actions.handleClosePreviewFile(this.updateState)}
                />

                <CommonToast 
                    toast={Action.Toast} 

                    onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                />

                <CommonConfirmModal 
                    Action={Action}
                    Deletes={Deletes}

                    onCallback={async (e) => { 
                        let result = await Actions.handleControlModal(this.updateState, e);
                        if(result.action){
                            if (result.section === 'Delete'){ await this.deleteData(); }
                        }
                    }}
                />

                {util.isEmpty(isFk) ? 
                    <Row>
                        <Col xs={10} sm={8} md={12} className="mb-3">
                            <Alert key="light" variant="danger" className="custom-alert-border">
                                <i className="fa-classic fa-light fa-circle-exclamation fa-fw me-2"></i>
                                 กรุณาบันทึก ข้อมูลนักศึกษา ก่อนดำเนินการ บันทึก ข้อมูลสถานศึกษา
                            </Alert>  
                        </Col>
                    </Row>
                :
                    <>
                        <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
            
                        <Row>
                            <Col xs={10} sm={8} md={12}>
                                <>
                                    <Table 
                                        responsive 
                                        borderless 
                                        className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                                        style={{marginTop: '0px'}}
                                    >
                                        <thead>
                                            <tr>
                                                <th className="th-td-align-center th-width-50p th-font-sm">#</th>
                                                <th className="th-td-align-center th-width-auto th-font-sm">สถานประกอบการ</th>   
                                                <th className="th-width-250p"></th>                                   
                                                <th className="th-width-75p"></th>
                                                <th className="th-td-align-center th-width-75p">
                                                    {DataTable?.rows?.length > 0 && !!Deletes?.deletes?.length && (
                                                        <CommonButton 
                                                            task="delete-no-text" 
                                                            rounded={true}
                                                            disabled={false}
                                                            callback={(e) => 
                                                                Actions.handleControlModal(this.updateState, {mode: 'confirm-delete', show: true, action: false})
                                                            } 
                                                        />
                                                    )}                                          
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {DataTable.rows.map((row, index) => {
                                                    
                                                Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });

                                                rowId++;

                                                let del = true;

                                                if( row.type_a_student_profile_rows > 0 ){ del = false; }

                                                return (    
                                                    <React.Fragment key={`${rowId}-${row.id}`}>
                                                        <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                            <td className="th-td-align-center td-font-sm align-top">
                                                                <CommonRowId rowId={rowId}/>
                                                            </td>
                                                            <td className="td-font-sm align-top" title={row.enterprise_name}>
                                                                {row.enterprise_name}                                                                   

                                                                {(row.years || row.years) && (
                                                                    <p className="title-xs text-muted mt-1 mb-0 d-flex flex-wrap align-items-center">
                                                                        {row.years && (
                                                                            <>
                                                                                <i className="fa-classic fa-light fa-school fa-fw me-2"></i>
                                                                                ปีการศึกษา {row.years}
                                                                            </>
                                                                        )}
                                                                    </p>
                                                                )}

                                                            </td>
                                                            <td className="th-td-align-center align-top">
                                                                  <Button 
                                                                        variant="primary"
                                                                        className="d-flex align-items-center btn-rounded" 
                                                                        size="xs"
                                                                        onClick={(e) => onDrillDownInline(
                                                                            {   key: 'type_a_new_student_dual_coop_welfare',  
                                                                                fk: 'type_a_new_student_dual_coop_profile_id',
                                                                                val: row.id,
                                                                                page: this.state.DataTable.pagination.currentPage,
                                                                            })}
                                                                    >
                                                                        <i className="fa-classic fa-light fa-circle-chevron-down fa-fw me-2"></i> 
                                                                        ร่วมสนับสนุน/รับเข้าทำงาน 
                                                                        <Badge bg="dark" pill className="ms-2">{util.formatNumber(row.type_a_student_profile_rows, true)}</Badge>                                                     
                                                                    </Button>
                                                            </td>
                                                            <td className="th-td-align-center align-top">
                                                                <CommonButton 
                                                                    task="edit" 
                                                                    rounded={false}
                                                                    disabled={false}
                                                                    inlineClass="btn-font-sm"
                                                                    callback={(e) => this.fetchForEdit({id: row.id})} 
                                                                />
                                                            </td>
                                                            <td className="th-td-align-center align-top">
                                                                {del && (
                                                                    <Form.Check 
                                                                        type="checkbox"
                                                                        name="deletes"
                                                                        value={row.id}
                                                                        checked={Deletes.deletes.includes(row.id)}
                                                                        onChange={(e) => Actions.handleDataTableToggleDelete(this.updateState, e)} 
                                                                        className="checkbox-font-sm" 
                                                                    />
                                                                )}                                                        
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>                                
                                                )
                                            })}
                                          
                                            <React.Fragment key={`inline-input-form`}>
                                                <tr ref={this.inlineInputRowRef}>
                                                    <td className="th-td-align-center align-top"><i className="fa-classic fa-light fa-circle-arrow-right fa-fw"></i></td>   
                                                    <td colSpan="2" className="align-top">

                                                        <div>
                                                            <Row>
                                                                {/* <Col md="4" className="mb-3">
                                                                    <CommonSelect
                                                                        element="Inputs"
                                                                        input={Inputs.education_type_id}
                                                                        option={{source: 'db', data: Masterbase?.education_type}}
                                                                        size="sm"  
                                                                        hr={false}
                                                                        callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                                        disabled={false}                                                  
                                                                    />                                                                                                                                    
                                                                </Col> */}
                                                                <Col md="8" className="mb-3">
                                                                    <CommonSelect
                                                                        element="Inputs"
                                                                        input={Inputs.enterprise_id}
                                                                        option={{source: 'db', data: Masterbase?.enterprise}}
                                                                        size="sm"  
                                                                        hr={false}
                                                                        callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                                        disabled={false}                                                    
                                                                    />                                                                                                                                    
                                                                </Col>
                                                                <Col md="4" className="mb-3">                                                                                                                                  
                                                                    <CommonSelect
                                                                        element="Inputs"
                                                                        input={Inputs.years}
                                                                        option={{source: 'db', data: Masterbase?.yearBEOptions}}
                                                                        size="sm"
                                                                        hr={false}
                                                                        floatingLabel={true}
                                                                        callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                                    />                                                                                                                                 
                                                                </Col>                                                                  
                                                            </Row>                                                            
                                                        </div>                                                     </td>
                                                    <td colSpan = "2" className="align-top">
                                                        <div className="d-flex justify-content-center">
                                                            <CommonButton 
                                                                task={`${mode}-no-text`} 
                                                                disabled={isLoading ? true : Submit ? false : true}
                                                                callback={async (e) => await this.submitData() }
                                                            /> 
                                                            <CommonButton 
                                                                task="discard-no-text" 
                                                                inlineClass="ms-2" 
                                                                disabled={isLoading} 
                                                                callback={(e) => this.resetInlineInputs()}
                                                            />  
                                                        </div>                                                                                   
                                                    </td>                                                                                             
                                                </tr>
                                            </React.Fragment>

                                        </tbody>
                                    </Table>    
                                    
                                    <CommonAlert 
                                        alert={Action.Alert} 
                                        size="sm"
                                        callback={(e) => Actions.handleCloseAlert(this.updateState, 'Alert', e)}
                                    />    

                                    <CommonLoadingBar isLoading={isLoading} />   

                                    {!DataTable?.rows?.length > 0 && (
                                        <>{/** <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} /> */}</>  
                                    )}                                                    
                                </>   

                                {!Action.Loading.dataTable && (DataTable.pagination.totalPages > 1) && (
                                    <CommonPagination 
                                        Pagination={DataTable.pagination} 

                                        handlePagination={(paging) => {
                                            Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)                                    
                                        }}
                                    />
                                )}
                            </Col>
                        </Row>
                    </>
                }
            </Container>                        
        )
    }
}

export default InlineTypeAEnterprise;